import { createSlice } from "@reduxjs/toolkit";
import { LOCAL_STORAGE_KEYS } from "../../Util/constants";

const initialState = {
  modalStack: [],
  activeModal: null,
  dynamicModalVariant: null,
  activeAd: false,
  requests: {},
  requestErrorMessages: {},
  recentlyCreatedPuzzle: null,
};

export const REQUESTS = {
  SUBMIT_PUZZLE: "submit-puzzle",
  DELETE_PROFILE: "delete-profile",
};

export const stateSlice = createSlice({
  name: LOCAL_STORAGE_KEYS.STATE,
  initialState,
  reducers: {
    setRecentlyCreatedPuzzle: (state, action) => {
      state.recentlyCreatedPuzzle = action.payload;
    },
    setDynamicModal: (state, action) => {
      const { modalType, variant } = action.payload;
      state.dynamicModalVariant = variant;
      state.activeModal = modalType;
    },
    setModal: (state, action) => {
      state.activeModal = action.payload;
      state.modalStack = [action.payload, ...state.modalStack];
    },
    dismissModal: (state) => {
      state.dynamicModalVariant = null;
      state.modalStack.shift();
      state.activeModal = state.modalStack[0];
    },
    pushModal: (state, action) => {
      state.modalStack = [...state.modalStack, action.payload];
    },
    resetModalState: (state) => {
      return { ...initialState };
    },
    // Request
    startRequest: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: "loading" };
    },
    submitRequestSuccess: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: "success" };
    },
    // { payload : { request: 'requestname', message: 'errorMessage'}}
    submitRequestError: (state, action) => {
      state.requests = { ...state.requests, [action.payload.request]: "error" };
      state.requestErrorMessages = {
        ...state.requestErrorMessages,
        [action.payload.request]: action.payload.message,
      };
    },
    clearRequestStatus: (state, action) => {
      state.requests = { ...state.requests, [action.payload]: null };
      state.requestErrorMessages = {
        ...state.requestErrorMessages,
        [action.payload]: null,
      };
    },
  },
});

// Additional logic for saving and loading from localStorage
export const loadModalFromLocalStorage = () => {
  const storedState = localStorage.getItem(LOCAL_STORAGE_KEYS.STATE);
  if (!storedState) return stateSlice.initialState;
  const newStateSlice = JSON.parse(storedState);
  newStateSlice.modalStack = [];
  return newStateSlice;
};

export const saveStateToLocalStorage = (modal) => {
  const persistedState = { ...modal, activeModal: null };
  localStorage.setItem(
    LOCAL_STORAGE_KEYS.State,
    JSON.stringify(persistedState)
  );
};

// Action creators are generated for each case reducer function
export const {
  setModal,
  dismissModal,
  pushModal,
  setAd,
  dismissAd,
  setDynamicModal,
  resetModalState,
  startRequest,
  submitRequestSuccess,
  submitRequestError,
  clearRequestStatus,
  setRecentlyCreatedPuzzle
} = stateSlice.actions;

export default stateSlice.reducer;
